//基本路由 
export default {
     'about': resolve => require(['../page/About.vue'], resolve),
     'index': resolve => require(['../page/Index.vue'], resolve),
     'login': resolve => require(['../page/Login.vue'], resolve),
     'modify': resolve => require(['../page/Modify.vue'], resolve),
     'poster': resolve => require(['../page/Poster.vue'], resolve),
     'register': resolve => require(['../page/Register.vue'], resolve),
     'art/epitome': resolve => require(['../page/art/Epitome.vue'], resolve),
     'art/index': resolve => require(['../page/art/Index.vue'], resolve),
     'art/introduce': resolve => require(['../page/art/Introduce.vue'], resolve),
     'art/list': resolve => require(['../page/art/List.vue'], resolve),
     'art/rater': resolve => require(['../page/art/Rater.vue'], resolve),
     'art/study': resolve => require(['../page/art/Study.vue'], resolve),
     'art/studydetails': resolve => require(['../page/art/Studydetails.vue'], resolve),
     'coolart/details': resolve => require(['../page/coolart/Details.vue'], resolve),
     'coolart/index': resolve => require(['../page/coolart/Index.vue'], resolve),
     'coolart/goods/desc': resolve => require(['../page/coolart/goods/Desc.vue'], resolve),
     'coolart/goods/details': resolve => require(['../page/coolart/goods/Details.vue'], resolve),
     'coolart/goods/list': resolve => require(['../page/coolart/goods/List.vue'], resolve),
     'coolart/my/cart': resolve => require(['../page/coolart/my/Cart.vue'], resolve),
     'coolart/my/comment': resolve => require(['../page/coolart/my/Comment.vue'], resolve),
     'coolart/my/history': resolve => require(['../page/coolart/my/History.vue'], resolve),
     'coolart/my/integral': resolve => require(['../page/coolart/my/Integral.vue'], resolve),
     'coolart/my/order': resolve => require(['../page/coolart/my/Order.vue'], resolve),
     'coolart/my/stars': resolve => require(['../page/coolart/my/Stars.vue'], resolve),
     'coolart/my/works': resolve => require(['../page/coolart/my/Works.vue'], resolve),
     'coolart/preference/uart': resolve => require(['../page/coolart/preference/Uart.vue'], resolve),
     'coolart/preference/weekstar': resolve => require(['../page/coolart/preference/Weekstar.vue'], resolve),
     'coolart/preference/weekstardetail': resolve => require(['../page/coolart/preference/Weekstardetail.vue'], resolve),
     'coolart/scheme/about': resolve => require(['../page/coolart/scheme/About.vue'], resolve),
     'coolart/scheme/list': resolve => require(['../page/coolart/scheme/List.vue'], resolve),
     'coolart/theme/details': resolve => require(['../page/coolart/theme/Details.vue'], resolve),
     'coolart/theme/list': resolve => require(['../page/coolart/theme/List.vue'], resolve),
     'coolart/theme/listfornewtheme': resolve => require(['../page/coolart/theme/Listfornewtheme.vue'], resolve),
     'free/artist': resolve => require(['../page/free/Artist.vue'], resolve),
     'free/details': resolve => require(['../page/free/Details.vue'], resolve),
     'free/footerbar': resolve => require(['../page/free/Footerbar.vue'], resolve),
     'free/index': resolve => require(['../page/free/Index.vue'], resolve),
     'free/list': resolve => require(['../page/free/List.vue'], resolve),
     'free/more': resolve => require(['../page/free/More.vue'], resolve),
     'media/download': resolve => require(['../page/media/Download.vue'], resolve),
     'media/footer': resolve => require(['../page/media/Footer.vue'], resolve),
     'media/information': resolve => require(['../page/media/Information.vue'], resolve),
     'participatingartists/details': resolve => require(['../page/participatingartists/Details.vue'], resolve),
     'participatingartists/index': resolve => require(['../page/participatingartists/Index.vue'], resolve),
     'solicitation/index': resolve => require(['../page/solicitation/Index.vue'], resolve),
     'solicitation/subject': resolve => require(['../page/solicitation/Subject.vue'], resolve),
     'solicitation/personal/add': resolve => require(['../page/solicitation/personal/Add.vue'], resolve),
     'solicitation/personal/index': resolve => require(['../page/solicitation/personal/Index.vue'], resolve),
     'solicitation/personal/preview': resolve => require(['../page/solicitation/personal/Preview.vue'], resolve),
     'solicitation/personal/works': resolve => require(['../page/solicitation/personal/Works.vue'], resolve),
     'solicitation/personal/worksinfo': resolve => require(['../page/solicitation/personal/Worksinfo.vue'], resolve),
     'works/details': resolve => require(['../page/works/Details.vue'], resolve),
     'works/index': resolve => require(['../page/works/Index.vue'], resolve),

       //首页
      '/': resolve => require(['../page/Index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/base.js